<div style="display: flex; flex: 0 0 100%; justify-content: center">
	@if (!editUser) {
	<div [innerHtml]="stepperText" class="dialog-stepper"></div>
	}
</div>
@if (stepper === 1) {
<h1 mat-dialog-title class="notification-title">{{ 'insights.administration.users.useraccess.step1title' | translate }}</h1>
} @if (stepper === 2) {
<h1 mat-dialog-title class="notification-title">{{ 'insights.administration.users.useraccess.' + (editUser ? 'step2title_edit' : 'step2title') | translate }}</h1>
} @if (stepper === 3) {
<h1 mat-dialog-title class="notification-title">{{ 'insights.administration.users.useraccess.step3title' | translate }}</h1>
} @if (stepper === 2) {
<mat-dialog-content>
	<p class="mat-caption">{{ 'insights.administration.users.useraccess.step2.formtitle' | translate }}</p>
	<form style="margin-top: 15px" (keydown.enter)="editUser ? saveUser() : validateUser()" [formGroup]="form">
		<mat-label class="mat-subtitle-2">{{ 'insights.administration.users.useraccess.step2.inputemail.label' | translate }}</mat-label>
		<mat-form-field appearance="outline" class="dialog">
			<input type="email" matInput [placeholder]="'insights.administration.users.useraccess.step2.inputemail.placeholder' | translate" [formControl]="emailControl" [readonly]="true" />
		</mat-form-field>
		<mat-label class="mat-subtitle-2">{{ 'insights.administration.users.useraccess.step2.inputname.label' | translate }}</mat-label>
		<div class="error-label mat-subtitle-2">
			@if (nameError) {
			<mat-error style="margin-left: auto">{{ 'insights.administration.users.useraccess.step2.inputname.error' | translate }}</mat-error>
			}
		</div>
		<mat-form-field appearance="outline" class="dialog">
			<input
				type="text"
				matInput
				autofocus
				[placeholder]="
          'insights.administration.users.useraccess.step2.inputname.placeholder'
            | translate
        "
				[formControl]="nameControl"
				[readonly]="editUser"
				(input)="alphaNumberOnly($event)"
				(paste)="onPaste($event)"
				(keypress)="alphaNumberOnly($event)"
				maxlength="60" />
		</mat-form-field>
		@if (!editUser) {
		<div class="error-label">
			<mat-label class="mat-subtitle-2">{{ 'insights.administration.users.useraccess.step2.inputrights.label' | translate }}</mat-label>
			@if (showRoleError) {
			<mat-error style="margin-left: auto" class="mat-subtitle-2">{{ 'insights.administration.users.useraccess.step2.inputrights.error' | translate }}</mat-error>
			}
		</div>
		} @if (!editUser) {
		<mat-form-field appearance="outline" class="dialog">
			<mat-select [formControl]="policyControl" name="policies" (selectionChange)="onPolicyChange($event)">
				<mat-option value="empty">--</mat-option>
				@for (policy of policies; track policy) {
				<mat-option [value]="policy">{{ policy.name }}</mat-option>
				}
			</mat-select>
		</mat-form-field>
		}
		<div class="error-label">
			<mat-label class="mat-subtitle-2">{{ 'insights.administration.users.useraccess.step2.inputinterval.label' | translate }}</mat-label>
			@if (showError) {
			<mat-error style="margin-left: auto; font-size: 12px" class="mat-subtitle-2">{{ 'insights.administration.users.useraccess.step2.inputinterval.error' | translate }}</mat-error>
			}
		</div>
		<mat-form-field appearance="outline" class="dialog" [ngClass]="{'mat-form-field-invalid': !form.valid}">
			<input required OnlyNumbers type="number" min="0" max="600" step="5" matInput [formControl]="slideshowControl" (keyup)="onFocusOutEvent($event)" />
		</mat-form-field>
	</form>
</mat-dialog-content>
} @if (stepper === 3) {
<mat-dialog-content>
	<p class="mat-caption">{{ 'insights.administration.users.useraccess.step3.formtitle' | translate }}</p>
	<details class="more-details">
		<summary class="mat-caption">{{ 'insights.administration.users.useraccess.step3.details' | translate }}</summary>
		<form style="margin-top: 15px" (keydown.enter)="saveUser()">
			<mat-form-field appearance="outline" class="dialog" style="font-size: 14px">
				<textarea matInput rows="13" readonly="true" resize="false">
                        {{
                        permissions
                        }}</textarea>
			</mat-form-field>
		</form>
	</details>
</mat-dialog-content>
} @if (stepper === 1) {
<mat-dialog-content>
	<div class="error-label mat-subtitle-2">
		@if (emailControl.hasError('email') && !userExist && !domainFederated) {
		<mat-error style="margin-left: auto">{{ 'login.inputEmail.error' | translate }}</mat-error>
		} @if (emailControl.hasError('plusAddress')) {
		<mat-error style="margin-left: auto">{{ 'insights.administration.users.useraccess.step1.invalid_plus_address' | translate }}</mat-error>
		} @if (userExist) {
		<mat-error style="margin-left: auto">{{ 'insights.administration.users.useraccess.step1.userexist' | translate }}</mat-error>
		} @if (userMustExist) {
		<mat-error style="margin-left: auto">{{ 'insights.administration.users.useraccess.step1.usermustexist' | translate }}</mat-error>
		} @if (domainFederated) {
		<mat-error style="margin-left: auto">{{ 'insights.administration.users.useraccess.step1.domainFederated' | translate }}</mat-error>
		}
	</div>
	<mat-form-field appearance="outline" style="font-size: 14px; width: 100%">
		<input
			(keydown.enter)="searchUser()"
			matInput
			type="email"
			id="emailInput"
			cdkFocusInitial
			[placeholder]="
        'insights.administration.users.useraccess.step1.emailsearch' | translate
      "
			[formControl]="emailControl"
			[errorStateMatcher]="matcher" />
	</mat-form-field>
</mat-dialog-content>
}
<div mat-dialog-actions align="end">
	@if (stepper === 1 || (stepper === 2 && editUser)) {
	<button mat-stroked-button (click)="onNoClick()" class="button-border-color">{{ 'insights.administration.users.useraccess.cancelbtn' | translate }}</button>
	} @if ((stepper === 2 && !editUser) || stepper === 3) {
	<button mat-stroked-button (click)="previous()" class="button-border-color">{{ 'insights.administration.users.useraccess.previousbtn' | translate }}</button>
	} @if (stepper === 1) {
	<button appPreventDoubleClick mat-flat-button color="primary" (throttledClick)="searchUser()" [disabled]="emailControl.hasError('email') || emailControl.hasError('plusAddress') || emailControl.value === ''">{{ 'insights.administration.users.useraccess.nextbtn' | translate }}</button>
	} @if (stepper === 2 && !data) {
	<button appPreventDoubleClick mat-flat-button color="primary" cdkFocusInitial (throttledClick)="validateUser()" [disabled]="showError || showRoleError">{{ 'insights.administration.users.useraccess.nextbtn' | translate }}</button>
	} @if (stepper === 2 && data) {
	<button appPreventDoubleClick [throttleTime]="20000" mat-flat-button color="primary" cdkFocusInitial (throttledClick)="saveUser()" [disabled]="showError || showRoleError">{{ 'insights.administration.users.useraccess.savebtn' | translate }}</button>
	} @if (stepper === 3) {
	<button appPreventDoubleClick [throttleTime]="20000" mat-flat-button color="primary" cdkFocusInitial (window:keypress)="onKeyDown($event)" (throttledClick)="saveUser()">{{ 'insights.administration.users.useraccess.savebtn' | translate }}</button>
	}
</div>
